// 荣峰服务器   测试服务器
// var basicUrl = process.env.NODE_ENV === 'development' ? "http://192.168.0.138:700" : 'https://slczb.sunray365.com:98'

// 测试服务器
var basicUrl = 'https://slczb.sunray365.com:98'
//var basicUrl = 'http://10.10.11.250:700'

export default basicUrl
